module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "h3",
    attrs: {
      "id": "ch07"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("SEVEN")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("God? Are You here? Are You near?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I dreamed I was floating upwards, but I have plummeted all the way down. No one will see the car. Harry chose black because he thought it looked expensive. Pride, one of the deadly sins, though I don’t mean to tattle. He died the year after the purchase, his death unrelated—You would know.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Am I meant to die in the ravine? Is this a long-range plan? If so, why did You spare me on the way down? The lack of warning is truly frightening.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I haven’t been in touch for a while, I know. Last time I was at morning service, I had a coughing fit and had to remove myself to a rear pew. I left before the service was over and haven’t been back. Phil attends chapel at the Haven on Sundays and I don’t have to pick her up any more. Truth to tell, I haven’t made the effort to go by myself.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There should be tire marks on the shoulder up there. The miracle is, my shell is cracked but I don’t feel so damaged inside. "), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _vm._v("I must be scratched, bruised, splattered with blood, though it’s hard to see.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Stay on track, Georgie. You were talking to God. Perhaps prayer will help. Any prayer will do. Try to remember the Creed.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It’s been a while. I’ll stare at the sky and concentrate. There’s nothing up there but an underbelly of cloud that blocks most of the light. Or is darkness descending?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Go ahead, try the prayer.")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("I believe in God, the Father Almighty"), _c('br'), _vm._v("Maker of heaven and earth")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When you first look at a thing, sometimes you don’t see it clearly. A ragged rock, longer than my humerus, is trapped deep inside the decay of the giant root. And there are smooth stones, palm-sized, tucked as if they’ve been pocketed. The root must have set its trap when alive and underground. How slowly it would have grown around those cool, hard stones. And then—to lift them up as part of itself and break through earth.")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("Ibelieveingodthefatheralmightymakerofheavenandearthand injesuschristhisonlysonour")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("Brain is tired, head won’t work. When I was a child, I couldn’t understand why an entire congregation of Anglicans faced front and declared themselves to believe in the Catholic Church. There was a "), _c('em', [_vm._v("k")]), _vm._v(" at the end of the word in my parents’ prayer book—"), _c('em', [_vm._v("Catholick")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _vm._v("The Holy Catholick Church")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Communion of Sins—surely that should be Saints")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Communion of Saints")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("I’m rusty. I’ve forgotten the words. Ribs and bum are stuck to Canadian Shield. The woods around have begun to moan and breathe—or is it my own moaning and breathing I hear?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nicene! Another version. Yanked from a fold of grey matter, the word bobs like a float in the mind. My grandmother, Grand Dan, said I had the memory of an unwiped slate. But memory can also be a curse.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Perhaps God will send someone to look for me in this abyss.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Not very likely in these darkening shadows.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ah, the night drops over me, like a hood.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c11a6bec","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch07.vue
// module id = 108
// module chunks = 0